import * as React from "react";

const IconSocialFacebookHover: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 22"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path fill="#298CF0" d="M18.75.5H2.25A2.25 2.25 0 000 2.75v16.5a2.25 2.25 0 002.25 2.25h6.434v-7.14H5.73V11h2.954V8.439c0-2.914 1.734-4.523 4.39-4.523 1.273 0 2.603.227 2.603.227v2.86H14.21c-1.444 0-1.895.896-1.895 1.815V11h3.224l-.515 3.36h-2.709v7.14h6.434A2.25 2.25 0 0021 19.25V2.75A2.25 2.25 0 0018.75.5z"/></svg>;
};

export default React.memo(IconSocialFacebookHover);
